import { render, staticRenderFns } from "./board.vue?vue&type=template&id=4bd5fabd&scoped=true&"
import script from "./board.vue?vue&type=script&lang=js&"
export * from "./board.vue?vue&type=script&lang=js&"
import style0 from "./board.vue?vue&type=style&index=0&id=4bd5fabd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd5fabd",
  null
  
)

export default component.exports